module.exports = __webpack_public_path__ + "img/_DSC8024.850518d4.jpg";